import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from "react";
import { ModalAllder } from "./ModalAllder";
import { Button, Form } from "react-bootstrap";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
export default function PesModalGroup(param) {
    var setFieldValue = param.setFieldValue, handleChange = param.handleChange, values = param.values, errors = param.errors, modalConfirmCancel = param.modalConfirmCancel, setModalConfirmCancel = param.setModalConfirmCancel, modalSuccess = param.modalSuccess, setModalSuccess = param.setModalSuccess, modalSaveSuccess = param.modalSaveSuccess, setModalSaveSuccess = param.setModalSaveSuccess, modalDeliEndProcess = param.modalDeliEndProcess, setModalDeliEndProcess = param.setModalDeliEndProcess, modalNotApprove = param.modalNotApprove, setModalNotApprove = param.setModalNotApprove, modalAlert = param.modalAlert, setModalAlert = param.setModalAlert, attachments = param.attachments, setAttachments = param.setAttachments, handlePreviewFile = param.handlePreviewFile, modalReadyToDeliProcess = param.modalReadyToDeliProcess, setModalReadyToDeliProcess = param.setModalReadyToDeliProcess;
    var docFileInputRef = useRef(null);
    var deleteDocument = function(removeId) {
        setAttachments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        if (docFileInputRef.current) {
            docFileInputRef.current.value = "";
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2 flex justify-center",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalAlert,
                setModal: setModalAlert,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center pt-4",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: [
                            "กรุณาเพิ่มรายการสินค้า ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " อย่างน้อย 1 รายการ"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center pb-4 pt-5 ",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-auto",
                            onClick: function() {
                                return setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยืนยัน"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalNotApprove,
                setModal: setModalNotApprove,
                htitle: "ยืนยันการไม่อนุมัติ",
                hbtn: false,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "py-4",
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-3 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลไม่อนุมัติ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "not_approve_reason",
                                    onChange: handleChange,
                                    isInvalid: !values.not_approve_reason,
                                    value: values.not_approve_reason
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-2  tc-10",
                                    children: "การดำเนินการ"
                                }),
                                [
                                    "radio"
                                ].map(function(type) {
                                    return /*#__PURE__*/ _jsx("div", {
                                        className: "mb-3",
                                        children: /*#__PURE__*/ _jsx(Form.Check, {
                                            inline: true,
                                            label: "ยกเลิกเอกสาร",
                                            name: "dim_mst_pes_status_id",
                                            onChange: function() {
                                                return setFieldValue("dim_mst_pes_status_id", 5);
                                            },
                                            type: type,
                                            id: "pes$1rs-".concat(type, "-20"),
                                            className: "form-check-st-2 tc-7"
                                        })
                                    }, "inline-".concat(type));
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center pb-4 pt-5 ",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 ms-auto me-3 btn",
                                    onClick: function() {
                                        return setModalNotApprove(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: false
                                            });
                                        });
                                    },
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalConfirmCancel,
                setModal: setModalConfirmCancel,
                htitle: "ยืนยันการยกเลิก",
                hbtn: false,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "py-4",
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-3 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการยกเลิก ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 5,
                                    name: "not_approve_reason",
                                    onChange: handleChange,
                                    isInvalid: !values.not_approve_reason,
                                    value: values.not_approve_reason
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center pb-4 pt-4 ",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 ms-auto me-3 btn",
                                    onClick: function() {
                                        return setModalConfirmCancel(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: false
                                            });
                                        });
                                    },
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function(e) {
                                        // e.preventDefault();
                                        setFieldValue("dim_mst_pes_status_id", 5);
                                    },
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDeliEndProcess,
                setModal: setModalDeliEndProcess,
                htitle: "ยืนยันการจัดส่ง",
                hbtn: false,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "py-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-2  tc-10",
                                    children: "การดำเนินการ"
                                }),
                                [
                                    "radio"
                                ].map(function(type) {
                                    return /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                inline: true,
                                                label: "จัดส่งสำเร็จ",
                                                name: "is_delivery_success",
                                                type: type,
                                                id: "pes$1rs-".concat(type, "-21"),
                                                className: "form-check-st-2 tc-7",
                                                onChange: function() {
                                                    return setFieldValue("is_delivery_success", true);
                                                },
                                                checked: values.is_delivery_success,
                                                value: true
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                inline: true,
                                                label: "จัดส่งไม่สำเร็จ",
                                                name: "is_delivery_success",
                                                type: type,
                                                id: "pes$1rs-".concat(type, "-22"),
                                                className: "form-check-st-2 tc-7",
                                                onChange: function() {
                                                    return setFieldValue("is_delivery_success", false);
                                                },
                                                checked: !values.is_delivery_success,
                                                value: false
                                            })
                                        ]
                                    }, "inline-".concat(type));
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "max-w-[275px]",
                            children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                dateAdapter: AdapterDayjs,
                                className: "h-[40px] ",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "grow ",
                                        children: /*#__PURE__*/ _jsx(DatePicker, {
                                            format: "DD/MM/YYYY",
                                            slotProps: {
                                                textField: {
                                                    InputLabelProps: {
                                                        shrink: true
                                                    },
                                                    error: !!errors.updated_success_delivery_at
                                                }
                                            },
                                            label: /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    "วันที่ ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "tc-16",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            className: "w-full ",
                                            sx: {
                                                ".MuiInputBase-formControl": {
                                                    height: "53px",
                                                    borderRadius: "8px"
                                                },
                                                ".MuiFormLabel-root": {
                                                    fontFamily: "Sarabun"
                                                },
                                                ".MuiOutlinedInput-notchedOutline": {
                                                    border: "1px solid rgba(76, 78, 100, 0.22)"
                                                }
                                            },
                                            name: "updated_success_delivery_at",
                                            value: values.updated_success_delivery_at ? dayjs(values.updated_success_delivery_at) : null,
                                            onChange: function(date) {
                                                var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                setFieldValue("updated_success_delivery_at", formattedDate);
                                            }
                                        })
                                    })
                                })
                            })
                        }),
                        !values.is_delivery_success && /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-3 mt-4 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการที่ส่งไม่สำเร็จ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 5,
                                    name: "undelivered_reason",
                                    onChange: handleChange,
                                    isInvalid: !values.undelivered_reason,
                                    value: values.undelivered_reason
                                })
                            ]
                        }),
                        values.is_delivery_success && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "tc-10 mt-5 mb-3",
                                    children: "เอกสารที่เกี่ยวข้อง"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "pb-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("button", {
                                            type: "button",
                                            className: "btn  btn-upload-file mb-4",
                                            onClick: function(e) {
                                                var _docFileInputRef_current;
                                                (_docFileInputRef_current = docFileInputRef.current) === null || _docFileInputRef_current === void 0 ? void 0 : _docFileInputRef_current.click();
                                            },
                                            children: "อัพโหลดไฟล์แนบ"
                                        }),
                                        /*#__PURE__*/ _jsx("input", {
                                            type: "file",
                                            name: "",
                                            className: "fileUpload hide-input",
                                            id: "fileUpload-2",
                                            accept: ".pdf",
                                            onChange: function(e) {
                                                handlePreviewFile(e);
                                            },
                                            ref: docFileInputRef
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "d-flex align-items-center flex-wrap",
                                            children: attachments.map(function(item, index) {
                                                return /*#__PURE__*/ _jsxs("div", {
                                                    className: "d-flex align-items-center me-3 mb-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "me-3",
                                                            children: index + 1
                                                        }),
                                                        /*#__PURE__*/ _jsx("a", {
                                                            href: "".concat(item.docUrl),
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "docfile",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "icon ".concat(item.docFileType)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "name fs-18",
                                                                        children: item.docFile
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("button", {
                                                            type: "button",
                                                            className: "btn  btn-delete-file-cross ms-3",
                                                            onClick: function(e) {
                                                                return deleteDocument(item.id);
                                                            }
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center pb-4 pt-4 ",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 ms-auto me-3 btn",
                                    onClick: function() {
                                        return setModalDeliEndProcess(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: false
                                            });
                                        });
                                    },
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function(e) {
                                        // e.preventDefault();
                                        setFieldValue("dim_mst_pes_status_id", 4);
                                    },
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalReadyToDeliProcess,
                setModal: setModalReadyToDeliProcess,
                htitle: "ยืนยันการจัดส่ง",
                hbtn: false,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "py-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col items-center mt-[50px] mb-[40px]",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-bold fs-20",
                                    children: "คุณต้องการยืนยันการจัดส่งหรือไม่"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "tc-16 text-bold fs-16",
                                    children: "ระบบจะทำการตัดสต๊อกสินค้าหลังจากกดปุ่มยืนยัน"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center pb-4 pt-4 ",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 ms-auto me-3 btn",
                                    onClick: function() {
                                        return setModalReadyToDeliProcess(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: false
                                            });
                                        });
                                    },
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function() {
                                        setFieldValue("is_ready_to_delivery", true);
                                    },
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "ยืนยัน"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
